module.exports = __webpack_public_path__ + "media/images/sp/special_reports/icon_bouquet-cc9e16c6043dfc95f29d7b38b9c64d05.png";